import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import StatModel from "../models/StatModel";

export interface StatParam {
    masterAreas: string[],
    sizes: string[],
    customSizeMin: number,
    customSizeMax: number,
    startDate: string,
    endDate: string,
    includeOutdated: boolean,
    includeFixed: boolean,
    componentType: string
}

export interface StatResponse {
    tonnageStats: StatModel[],
    cargoStats: StatModel[],
}

const StatApi = {
    GetChart(param: StatParam) {
        return Api.post<StatParam, BaseResponse<StatResponse>>("/api/stat/GetChart", param);
    },
};
export default StatApi;